import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useEffect } from 'react';
import "./Modal.scss";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const ModalDots = ({isOpen, setIzOpen}) =>  {
  const handleClose = () => setIzOpen(false);

  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography className='modal__points-title' id="modal-modal-title" variant="h6" component="h2">
            ВНИМАНИЕ!
          </Typography>
          <Typography className='modal__points-text' id="modal-modal-description" sx={{ mt: 2 }}>
            Для участия в конкурсе в Казани регистрация в программе лояльности при добавлении точки обязательна
          </Typography>
          <button className='modal__points-button' onClick={handleClose}>Понятно</button>
        </Box>
      </Modal>
    </div>
  );
}

export default ModalDots;